import React from "react";

import { BaseLabel } from "../BaseLabel";
import { ITitleSubTitleLabel } from "./interface";

// Default colors
const colors = {
  default_base_black: "#000000",
  default_base_grey: "#666666",
};

export const TitleSubTitleLabel: React.FC<ITitleSubTitleLabel> = ({
  id,
  childrenThirdTitle,
  fontSizeTitle = "12px",
  fontSizeSubTitle = "12px",
  marginTop,
  marginBottom,
  marginLeft,
  marginRight,
  marginBetweenTitleAndSubTitle = "-8px",
  childrenTitle,
  childrenSubTitle,
  alignContent = "start",
  alignItems = "start",
  textAlign = "start",
  fontWeightTitle = "600",
  fontWeightSubTitle = "400",
  colorTitle,
  colorSubTitle,
  height,
}) => {
  return (
    <div
      id={id}
      style={{
        display: "flex",
        alignContent: alignContent,
        flexDirection: "column",
        alignItems: alignItems,
        textAlign: textAlign,
        justifyContent: "space-between",
        height: height,
      }}
    >
      <BaseLabel
        fontSize={fontSizeTitle}
        marginTop={marginTop ?? "12px"}
        color={colorTitle ?? colors.default_base_black}
        fontWeight={fontWeightTitle}
        marginLeft={marginLeft}
        marginRight={marginRight}
        marginBottom={marginBottom}
      >
        {childrenTitle}
      </BaseLabel>
      {childrenThirdTitle && (
        <BaseLabel
          fontSize={fontSizeSubTitle}
          marginTop={marginBetweenTitleAndSubTitle}
          color={colorSubTitle ?? colors.default_base_grey}
          fontWeight={fontWeightSubTitle}
          marginLeft={marginLeft}
          marginRight={marginRight}
          marginBottom={marginBottom}
        >
          {childrenThirdTitle}
        </BaseLabel>
      )}
      <BaseLabel
        fontSize={fontSizeSubTitle}
        marginTop={marginBetweenTitleAndSubTitle}
        color={colorSubTitle ?? colors.default_base_grey}
        fontWeight={fontWeightSubTitle}
        marginLeft={marginLeft}
        marginRight={marginRight}
        marginBottom={marginBottom}
      >
        {childrenSubTitle}
      </BaseLabel>
    </div>
  );
};
